module.exports = __webpack_public_path__ + "img/socail_media.0f9851b5.jpg";